import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

const ROUTE_NAME = 'profile:notary:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const CREATE = p('create')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(['PROFILE:USERS:VIEW_NOTARY'], options),
    }),
    route('create/', Display, CREATE, {
      meta: accessPermission(['PROFILE:USERS:ADD_NOTARY'], options),
    }),
    route(':id/', Display, DISPLAY, {
      props: true,
      meta: accessPermission(['PROFILE:USERS:VIEW_NOTARY'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
